import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-promotion-lock',
  templateUrl: './promotion-lock.component.html',
  styleUrls: ['./promotion-lock.component.scss']
})
export class PromotionLockComponent {

  public lock:any = {}
  private player_uuid:any;
  public adding_promotion:boolean = false;
  public promotions:any = [];
  public promotion_type:any;

  @Input() set setUserUUID(v:any) {
    this.player_uuid = v;
    this.init(v)
  }
  @Output() closeEvent = new EventEmitter();
  constructor(private http: HttpService, private route: ActivatedRoute) { 
    const uuid: Observable<string> = this.route.params.pipe(map(p => p['uuid']));
    
    uuid.subscribe(val => {
      if(val) {
        this.player_uuid = val;
        this.init(val)
      }
    })
  }

  async init(player_uuid:any) {
    let y = await this.http.post("/admin/player/active-promotion-lock-v2", {player_uuid})
    this.lock = y;
    this.lock.progress = parseFloat(this.lock.progress);
    this.lock.min_rolling = parseFloat(this.lock.min_rolling);
    this.lock.adjustment = 0
  }

  close() {
    this.closeEvent.emit(true)
  }

  async cancelPromotion() {
    let y:any = await this.http.post("/admin/player/cancel-promotion-lock-v2", this.lock)

    if(y.status) {
      this.init(this.player_uuid);
    }

  }


  async endPromotion() {
    let y:any = await this.http.post("/admin/player/end-promotion-lock-v2", this.lock)

    if(y.status) {
      this.init(this.player_uuid);
    }

  }

  async getCustomPromotion() {
    let y:any = await this.http.post("/admin/promotion/custom/list", {player_uuid: this.player_uuid})
    this.promotions = y.promotions;
  }

  async addPromotion() {
    this.adding_promotion = true;
    this.promotion_type = null;
    let y:any = await this.http.post("/admin/promotion/custom/list")
    this.promotions = y.promotions;
  }

  async newPromotion() {
    let y:any = await this.http.post("/admin/promotion/custom/create", {player_uuid: this.player_uuid, promotion_type: this.promotion_type})
    if(y.status) {
      this.adding_promotion = false;
      this.getCustomPromotion();
    }

    if(y.message) {
      this.http.toast(y.message, "error");
    }
  }
}
